module.exports = __webpack_public_path__ + "static/media/layers-icon.434a6d52.png";